import { Link } from "@remix-run/react";
import { Search, Download, TrendingUp, Play, ChevronDown } from "lucide-react";
import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";

export function HeroSection() {
  const scrollToEditorsChoice = () => {
    const element = document.getElementById('editors-choice');
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="relative bg-slate-900 text-white overflow-hidden" style={{ height: 'calc(100vh - 64px)' }}>
      {/* 视频背景 + CSS动画备用 */}
      <div className="absolute inset-0 w-full h-full">
        {/* 总是显示CSS动画背景作为基础 */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-blue-900/60 to-purple-900/60" />
        
        {/* CSS动画光效 */}
        <div className="absolute inset-0 opacity-40">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse" 
               style={{ animationDuration: '4s' }} />
          <div className="absolute top-3/4 right-1/4 w-80 h-80 bg-purple-500/20 rounded-full blur-3xl animate-pulse" 
               style={{ animationDuration: '6s', animationDelay: '2s' }} />
          <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-cyan-500/20 rounded-full blur-3xl animate-pulse" 
               style={{ animationDuration: '5s', animationDelay: '1s' }} />
        </div>
        
        {/* 客户端视频组件 - 全屏覆盖 */}
        <video
          className="absolute inset-0 w-full h-full object-cover pointer-events-none opacity-95"
          src="https://r2.stellarblademod.com/herosectionvideo.mp4"
          autoPlay
          muted
          loop
          playsInline
          onLoadedData={() => {/* Video loaded */}}
          onError={() => {/* Video failed, CSS background will show */}}
        />
      </div>
      
      {/* Dark Overlay for readability */}
      <div className="absolute inset-0 bg-black/60" />
      
      {/* Additional gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50" />
      
      <div className="relative container h-full flex flex-col justify-center items-center">
        <div className="text-center space-y-[2vh] w-full max-w-5xl">
          {/* Hero Content */}
          <div className="space-y-[1.5vh]">
            <div className="flex items-center justify-center space-x-2 mb-[1vh]">
              <img src="/favicon.ico" alt="Stellar Blade Mods" className="h-[3vh] w-[3vh]" />
              <span className="text-[2vh] font-medium text-blue-400">SBMods</span>
            </div>
            
            <h1 className="text-[8vh] font-bold leading-tight">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">Stellar Blade Mods</span>
              <br />
              Community Hub
            </h1>
            
            <p className="text-[2.5vh] text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Where passion meets discovery. A curated sanctuary for Stellar Blade enthusiasts to explore, share, and celebrate the finest modifications
            </p>
          </div>

          {/* Search Bar - 暂时注释掉 */}
          {/* <div className="max-w-2xl mx-auto">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
              <Input
                type="search"
                placeholder="Search for mods..."
                className="pl-12 pr-4 py-4 text-lg bg-white/10 border-white/20 text-white placeholder:text-gray-300 focus:bg-white/20"
              />
              <Button 
                className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-blue-600 hover:bg-blue-700"
                size="sm"
              >
                Search
              </Button>
            </div>
          </div> */}

          {/* Action Buttons - 暂时注释掉 */}
          {/* <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="lg" className="bg-blue-600 hover:bg-blue-700" asChild>
              <Link to="/mods">
                <Download className="mr-2 h-5 w-5" />
                Browse Mods
              </Link>
            </Button>
            
            <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-black" asChild>
              <Link to="/mods/trending">
                <TrendingUp className="mr-2 h-5 w-5" />
                Trending Now
              </Link>
            </Button>
          </div> */}

          {/* Community Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-[3vh] pt-[3vh]">
            <div className="text-center">
              <div className="text-[4vh] font-bold text-blue-400">500+</div>
              <div className="text-[1.5vh] text-gray-300">Shared Mods</div>
            </div>
            <div className="text-center">
              <div className="text-[4vh] font-bold text-purple-400">50+</div>
              <div className="text-[1.5vh] text-gray-300">Active Members</div>
            </div>
            <div className="text-center">
              <div className="text-[4vh] font-bold text-green-400">10K+</div>
              <div className="text-[1.5vh] text-gray-300">Downloads</div>
            </div>
            <div className="text-center">
              <div className="text-[4vh] font-bold text-yellow-400">Daily</div>
              <div className="text-[1.5vh] text-gray-300">New Shares</div>
            </div>
          </div>
        </div>
        
        {/* 向下滚动提示 */}
        <div 
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center space-y-4 cursor-pointer hover:opacity-80 transition-opacity"
          onClick={scrollToEditorsChoice}
        >
          <span className="text-[2vh] text-white font-semibold tracking-widest uppercase">DISCOVER MODS</span>
          <div className="animate-bounce">
            <ChevronDown className="h-[4vh] w-[4vh] text-white" />
          </div>
        </div>
      </div>
    </section>
  );
} 